<template>
  <div v-if="campaignData" class="is-size-5-desktop card">
    <div class="card-content">
      <figure class="image is-128x128 padding-5 content-centered">
        <img v-bind:src="campaignData.logo" v-if="campaignData.logo">
        <img src="https://bulma.io/images/placeholders/128x128.png" v-else>
      </figure>
      <div class="has-text-centered">
        <p class="title">{{ campaignData.brandName }} {{ campaignData.branchName }}</p>
        <p class="subtitle" v-if="campaignData.campaign">{{ campaignData.campaign.title }}</p>
      </div>
      <div class="buttons is-centered padding-5">
        <a class="button is-success is-medium is-rounded" v-on:click="$emit('displayfeedback')">Begin Feedback</a>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackWelcomePage',
  props: ['campaignData']
}
</script>
